/*
  엑셀 생성을 요청했지만 바로 받을 수 없을 때, 다운로드 페이지로 갈지 묻는 모달.

  공통 ExcelRequestCompleteModal 은 Main·SikdaeGivenList·UserSikdaeGivenList 등이 함께 쓰고 있어
  문구나 버튼을 고치면 그 화면들까지 바뀐다. 그래서 이 화면 전용으로 따로 둔다.
  모양(폭·여백·글자색)은 공통 모달과 맞춰 다른 화면과 이질감이 없게 한다.
*/
import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

const ExcelDownloadMoveModal = ({ open, close, onMove }) => (
  <Modal open={open} onClose={close} style={{ width: 510 }}>
    <Modal.Header style={{ border: 'none', padding: 20 }}>엑셀 생성 중</Modal.Header>
    <div style={{ padding: '0px 20px 20px', fontSize: 16, lineHeight: '24px', color: '#747474' }}>
      <div>파일 생성에 시간이 걸리고 있습니다.</div>
      <div>생성이 완료되면 &quot;엑셀 다운로드&quot;에서 확인할 수 있습니다.</div>
      <div>지금 이동하시겠습니까?</div>
      <div style={{ paddingTop: 20, textAlign: 'end' }}>
        <Button color="black" inverted style={{ marginRight: 10 }} onClick={close}>
          취소
        </Button>
        <Button color="green" onClick={onMove}>
          확인
        </Button>
      </div>
    </div>
  </Modal>
);

export default ExcelDownloadMoveModal;
